import React from 'react';
import { useIntl } from 'react-intl';
import { localize } from '@saviynt/common';
import { Link } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { msgs } from '../../../constants';

function ViewScheduleLink({ className, setIsScheduleViewOpen, kind }) {
  const intl = useIntl();

  const LINK_TEXT = localize(intl, msgs.pam.modalPage.page.viewScheduleLink);

  const handleScheduleModal = (event) => {
    event.preventDefault();

    setIsScheduleViewOpen(true);
  };

  const isKindAccordion = kind === 'accordion';

  return (
    <Link
      className={className}
      href='/'
      url='/'
      onClick={(e) => {
        handleScheduleModal(e);
      }}
      text={LINK_TEXT}
      prefixIconKind={isKindAccordion ? 'Calendar' : null}
      suffixIconKind={!isKindAccordion ? 'ChevronRight' : null}
      target='_self'
      shouldStopPropagation
    />
  );
}

ViewScheduleLink.propTypes = {
  className: PropTypes.string,
  setIsScheduleViewOpen: PropTypes.func.isRequired,
  kind: PropTypes.string,
};

ViewScheduleLink.defaultProps = { className: '', kind: 'accordion' };

export default ViewScheduleLink;
